import { type ButtonProps, Button as HeroButton } from "@heroui/react";
import { type FC } from "react";
import { twMerge } from "tailwind-merge";

export const Button: FC<
  { children: React.ReactNode; btnType?: "primary" | "outline" } & ButtonProps
> = ({ children, className, btnType = "primary", ...props }) => {
  return (
    <HeroButton
      className={twMerge(
        "w-60 h-11 text-base",
        btnType === "primary" ? "bg-[#3d3d3d] text-white" : "",
        btnType === "outline" ? "bg-white border border-color-border-3" : "",
        className,
      )}
      {...props}
    >
      {children}
    </HeroButton>
  );
};
